/**
 * 작성자 : 한영광
 * 날짜 : 2025.06.12
 * 경로 : 설정관리 > 방문자 설정 관리 > QR 코드
 */

import { useRecoilValue } from 'recoil';
import { userState } from '../atoms';
import QRCode from 'react-qr-code';
import { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import LoadButton from './button/LoadButton';
import { useTranslation } from 'react-i18next';

const QrCode = () => {
  const userInfo = useRecoilValue(userState);
  const svgRef = useRef(null);
  const printRef = useRef(null);
  const qrValue = `${process.env.REACT_APP_SAFEEDU_URL}/visit?code=${userInfo.hCd}${userInfo.sCd}`;
  const { t } = useTranslation();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    pageStyle: `
      @media print {
        body {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100vh;
          margin: 0;
        }
        svg {
          display: block;
          margin: auto;
        }
      }
    `,
  });

  const handleQrClick = () => {
    const svg = svgRef.current;
    if (svg) {
      const serializer = new XMLSerializer();
      const svgString = serializer.serializeToString(svg);
      const base64 = window.btoa(unescape(encodeURIComponent(svgString)));
      const imgSrc = `data:image/svg+xml;base64,${base64}`;
      const newWindow = window.open('', '_blank', 'width=2000,height=1000');
      if (newWindow) {
        newWindow.document.write(`
          <html>
            <head><title>QR 코드</title></head>
            <body style="display:flex;justify-content:center;align-items:center;height:100vh;margin:0;">
              <img src="${imgSrc}" style="width:750px;height:750px;"/>
            </body>
          </html>
        `);
      }
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '90%' }}>
      <div ref={printRef} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <h1 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '1rem', color: 'var(--text-primary)' }}>
          {userInfo.hName} {userInfo.sName}
        </h1>
        <QRCode ref={svgRef} size={350} value={qrValue} onClick={handleQrClick} style={{ cursor: 'pointer' }} />
      </div>
      <div style={{ marginTop: '2rem' }}>
        <LoadButton text={t('인쇄')} isLoading={false} color='blue' onClick={handlePrint} />
      </div>
    </div>
  );
};

export default QrCode;
